const participantString = (selection) => {
  let str = '';
  selection.map((entry) => {
    if (entry.value) {
      str += (str ? ', ' : '') + `${entry.label.charAt(0).toUpperCase()}${entry.label.slice(1)} ${entry.value}`;
    }
  });
  return str;
}

export default participantString;
